module.exports = __webpack_public_path__ + "epdf-app/dashboard/envelope/waiting/reject-evl-modal-3S8VAzzm.html";